import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: [],
}

export const report: any = createSlice({
    name: 'REPORT',
    initialState,
    reducers: {
        setReport: (state: any, action: any) => {
            state.value = action.payload
        },
    },
})

export const { setReport } = report.actions

export default report.reducer
